import { Identity } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { LeaveRegistration } from '../model/out/leave-registration';
import { Observable } from 'rxjs';
import { Transport } from '../model/Transport';
import { environment } from 'src/environments/environment';
import { AreaGate } from '../model/areaGate';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class RegisterLeaveService {

  constructor(private http: HttpService) { }

  getAreaGates() {
    return this.http.postWithContext<AreaGate[]>(`${environment.registerLeaveEndpoint}/area-gates`, {}).pipe(map(response => {
      const gates = new Array<AreaGate>();
      for (const entry of response) {
        gates.push(new AreaGate(entry));
      }
      return gates;
    }));
  }

  getTransport(identity: Identity): Observable<Transport> {
    return this.http.postWithContext<Transport>(`${environment.registerLeaveEndpoint}/transport`, identity);
  }

  accept(identity: LeaveRegistration): Observable<any> {
    return this.http.postWithContext<any>(`${environment.registerLeaveEndpoint}/accept`, identity);
  }

  decline(identity: LeaveRegistration) {
    return this.http.postWithContext<any>(`${environment.registerLeaveEndpoint}/decline`, identity);
  }
}
